import { customComparisionChartOptions, comparisionChartOptions } from "../src/chart_defaults"
import { formatDate } from "../src/utils"
import { updateComparisonTable } from "../src/reports"
import { downloadLink } from "../src/tools"

const PAGE_CONTENT = 'budget-comparison-page-content'
const COMPARISON_CANVAS_ID = 'six-month-view-chart' 
const SPEND_AND_FEES_CANVAS_ID = 'spend-and-fees-view-chart'
const SPEND_AND_FEES_TABLE_ID = 'comparison-spend-v-fees-table'

let spendAndFeesChart, comparisonChart, spendAndFeesRequest, comparisonRequest

jQuery(document).ready(function () {
  if (!jQuery(`.${PAGE_CONTENT}`).length) return
  bindBudgetComparisonPage()
})

function bindBudgetComparisonPage() {
  bindBudgetSelect2()
  bindDateRangeSelector()
  bindComparisonTypeToggle()
  bindCategoryTypeToggle()
  initializeSpendAndFeesGraph()
  initializedComparisonGraph()
  bindComparisonDownload()
}

function bindBudgetSelect2() {
  new CraftySelect2({
    select: jQuery(`.${PAGE_CONTENT} #budget-comparison-multi-id`),
    onSelect: fetchReports,
    onUnselect: fetchReports,
    maximumSelectionLength: 4,
  }).init()
}

function bindDateRangeSelector() {
  jQuery(`.${PAGE_CONTENT} .date-holder`).on('dateSelected', function() {
    fetchReports()
  })
}

function bindComparisonTypeToggle() {
  $(`.${PAGE_CONTENT} input[type="radio"][name="view-type-toggle"]`).change(function() {
    jQuery(this).prop("checked", true)
    fetchComparisonReport()
  })
}

function bindCategoryTypeToggle() {
  $(`.${PAGE_CONTENT} input[type="radio"][name="category-toggle"]`).change(function() {
    jQuery(this).prop("checked", true)
    fetchSpendAndFeesReport()
  })
}

function bindComparisonDownload() {
  jQuery('.custom-comparison-download-link').click(downloadCustomComparisonReport)
}

function fetchReports() {
  toggleEmptyState()
  if (comparisonsSelected()) {
    fetchComparisonReport()
    fetchSpendAndFeesReport()
  }
}

function fetchComparisonReport() {
  const data = {report_name: 'custom_comparison', ...getComparisonFilters()}
  const url = reportUrl()
  comparisonRequest = comparisonChart.reset()
  return jQuery.ajax({
    url,
    type: "GET",
    dataType: "json",
    data,
    success: function(res) {
      const ctx = document.getElementById(COMPARISON_CANVAS_ID)
      ctx.style.display = 'block'
      const { labels, datasets } = res.data
      comparisonChart.data = { labels, datasets }
      comparisonChart.update()
      const $table = jQuery('#comparison-table')

      updateComparisonTable($table,  {labels, datasets})
    },
    beforeSend: () => {
      if (comparisonRequest != null) {
        comparisonRequest.abort()
      }
    },
    complete: () => {
      comparisonRequest = null
    },
  })
}

function reportUrl() {
  return  $('#six-month-view-wrapper').data('link')
}

function fetchSpendAndFeesReport() {
  const data = {report_name: 'custom_spend_v_fees', ...getSpendAndFeesFilters()}
  const url = reportUrl()
  spendAndFeesChart.reset()
  spendAndFeesRequest = jQuery.ajax({
    url,
    type: "GET",
    dataType: "json",
    data,
    success: function(res) {
      const ctx = document.getElementById(SPEND_AND_FEES_CANVAS_ID)
      ctx.style.display = 'block'
      const { labels, datasets } = res.data
      spendAndFeesChart.data = { labels, datasets }
      spendAndFeesChart.update()
      const $table = jQuery(`#${SPEND_AND_FEES_TABLE_ID}`)
      updateComparisonTable($table,  {labels, datasets})
    },
    beforeSend: () => {
      if (spendAndFeesRequest != null) {
        spendAndFeesRequest.abort()
      }
    },
    complete: () => {
      spendAndFeesRequest = null
    },
  })
}

function getPageFilters() {
  const from_range = formatDate(jQuery(`.${PAGE_CONTENT} #range_from`).val())
  const to_range = formatDate(jQuery(`.${PAGE_CONTENT} #range_to`).val())
  const comparisons = jQuery(`.${PAGE_CONTENT} #budget-comparison-multi-id`).val()
  return { comparisons, from_range, to_range }
}

function getComparisonFilters() {
  return { ...getPageFilters(), comparison_type: comparisonGrouping() }
}

function getSpendAndFeesFilters() {
  return { ...getPageFilters(), breakdown_category: spendAndFeeGrouping()  }
}

function toggleEmptyState() {
  if (comparisonsSelected()) {
    $('.empty-state--budgets').addClass('d-none')
    $(`#${SPEND_AND_FEES_CANVAS_ID}, #${COMPARISON_CANVAS_ID}, #${SPEND_AND_FEES_TABLE_ID}, #comparison-table`).removeClass('d-none')
  } else {
    $('.empty-state--budgets').removeClass('d-none')
    $(`#${SPEND_AND_FEES_CANVAS_ID}, #${COMPARISON_CANVAS_ID}, #${SPEND_AND_FEES_TABLE_ID}, #comparison-table`).addClass('d-none')
  }
}

function comparisonsSelected() {
  const { comparisons } = getPageFilters()
  return !!comparisons
}

function comparisonGrouping() {
  if (jQuery(`.${PAGE_CONTENT} #budget-view`).is(':checked')) return 'budgeted'
  if (jQuery(`.${PAGE_CONTENT} #spend-view`).is(':checked')) return 'spend'
  if (jQuery(`.${PAGE_CONTENT} #remaining-view`).is(':checked')) return 'remaining'
}

function spendAndFeeGrouping() {
  if (jQuery(`.${PAGE_CONTENT} #product-category`).is(':checked')) return 'product_total'
  if (jQuery(`.${PAGE_CONTENT} #labor-category`).is(':checked')) return 'personnel_total'
  if (jQuery(`.${PAGE_CONTENT} #equipment-category`).is(':checked')) return 'equipment_total'
  if (jQuery(`.${PAGE_CONTENT} #management-category`).is(':checked')) return 'management_fees_total'
}

function initializeSpendAndFeesGraph() {
  const ctx = document.getElementById(SPEND_AND_FEES_CANVAS_ID)
  if (ctx === null) return
  ctx.style.display = 'none'
  spendAndFeesChart = new Chart(ctx, {
    type: 'bar',
    options: comparisionChartOptions,
  })
}

function initializedComparisonGraph() {
  const ctx = document.getElementById(COMPARISON_CANVAS_ID)
  if (ctx === null) return
  ctx.style.display = 'none'
  comparisonChart = new Chart(ctx, {
    type: 'line',
    options: customComparisionChartOptions,
  })
}

function downloadCustomComparisonReport(e) {
  e.preventDefault()
  const filters = getPageFilters()
  const link = jQuery(this).data('link')
  if (!filters?.comparisons) return
  
  downloadLink(link, filters)
}

window.bindBudgetComparisonPage = bindBudgetComparisonPage
